export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12891.93d9a6c1.jpg";